import { getFromLocalStorage, saveToLocalStorage } from './localStorage';
import { checkPaymentTestModeOn, toggleTestPaymentMode } from './paymentTestMode';
import {
  LOCALSTORAGE_PARAMS_VAR,
  BUTTON_TITLE_TEST_PAYMENT_OFF,
  BUTTON_TITLE_TEST_PAYMENT_ON,
} from './consts';

const styles = {
  container: {
    position: 'fixed',
    top: '16px',
    left: '16px',
    padding: '8px',
    zIndex: '100',
    background: '#000',
    borderRadius: '3px',
    opacity: '.8',
  },
  title: {
    color: 'greenyellow',
    fontSize: '13px',
  },
  content: {
    color: 'tomato',
    fontSize: '13px',
  },
  bg: {
    content: '',
    position: 'absolute',
    top: '0',
    left: '0',
    bottom: '0',
    right: '0',
    background: '#000',
    borderRadius: '3px',
    opacity: '.6',
    zIndex: '-1',
  },
  button: {},
  innerContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: '8px 0 0',
    justifyContent: 'space-between',
  },
};

const setStyle = (node, styleObject) => {
  Object.keys(styleObject).forEach((styleName) => {
    // eslint-disable-next-line no-param-reassign
    node.style[styleName] = styleObject[styleName];
  });
};

const handleToggleTestPaymentButton = (titleNode) => (e) => {
  const hasTestPaymentMode = checkPaymentTestModeOn();

  // eslint-disable-next-line no-param-reassign
  e.target.innerHTML = hasTestPaymentMode
    ? BUTTON_TITLE_TEST_PAYMENT_OFF
    : BUTTON_TITLE_TEST_PAYMENT_ON;

  setStyle(titleNode, {
    ...styles.title,
    color: hasTestPaymentMode ? 'tomato' : 'greenyellow',
  });
  toggleTestPaymentMode();
};

const createRowNode = (title, content) => {
  const node = document.createElement('div');
  const titleNode = document.createElement('span');

  setStyle(node, styles.content);
  setStyle(titleNode, styles.title);

  titleNode.innerHTML = `${title}: `;

  node.appendChild(titleNode);
  node.appendChild(document.createTextNode(content));

  return node;
};

const createInputNode = (title) => {
  const node = document.createElement('div');
  const titleNode = document.createElement('span');
  const inputNode = document.createElement('input');

  setStyle(node, styles.content);
  setStyle(titleNode, styles.title);

  titleNode.innerHTML = `${title}: `;

  inputNode.value = getFromLocalStorage(LOCALSTORAGE_PARAMS_VAR);

  inputNode.addEventListener(
    'input',
    () => {
      saveToLocalStorage(LOCALSTORAGE_PARAMS_VAR, inputNode.value);
    },
    false
  );

  node.appendChild(titleNode);
  node.appendChild(inputNode);

  return node;
};

const createSwitchTestEnvButton = ({ localStorageTestPgKey }) => {
  const containerNode = document.createElement('div');
  const titleNode = document.createElement('div');
  const buttonNode = document.createElement('button');

  const hasTestPaymentMode = checkPaymentTestModeOn(localStorageTestPgKey);

  setStyle(titleNode, {
    ...styles.title,
    color: hasTestPaymentMode ? 'greenyellow' : 'tomato',
  });
  setStyle(containerNode, styles.innerContainer);
  setStyle(buttonNode, styles.button);

  titleNode.innerHTML = 'Тестовая оплата';

  buttonNode.innerHTML = hasTestPaymentMode
    ? BUTTON_TITLE_TEST_PAYMENT_ON
    : BUTTON_TITLE_TEST_PAYMENT_OFF;

  buttonNode.onclick = handleToggleTestPaymentButton(titleNode);

  containerNode.appendChild(titleNode);
  containerNode.appendChild(buttonNode);

  return containerNode;
};

export const addEnvNode = ({ data, ...restConfig }) => {
  const wrapNode = document.createElement('div');
  wrapNode.id = 'debug_env_id';

  try {
    Object.keys(data).forEach((paramKey) => {
      wrapNode.appendChild(createRowNode(paramKey, data[paramKey]));
    });

    wrapNode.appendChild(createInputNode('params'));
    wrapNode.appendChild(
      createSwitchTestEnvButton({
        localStorageTestPgKey: restConfig.localStorageTestPgKey,
      })
    );

    setStyle(wrapNode, styles.container);

    document.body.appendChild(wrapNode);
  } catch (err) {
    console.error('EASTER EGG: ', err);
  }
};

export const removeEnvNode = () => {
  const envNode = document.getElementById('debug_env_id');
  if (envNode) {
    envNode.parentNode.removeChild(envNode);
  }
};
